import React, { useRef } from "react";
import Modal from "react-bootstrap/Modal";
import Common_Back_Btn from "../../../common/common_components/common_back_btn/Common_Back_Btn";
import Black_Submit_Btn from "../../../common/common_btn/black_submit_btn/Black_Submit_Btn";
import { Form } from "react-bootstrap";
import Blue_Btn from "../../../common/common_btn/blue_btn/Blue_Btn";
import "./User_Management_Modal.css";
import { useNavigate } from "react-router-dom";

const User_Management_Modal = ({
  show,
  onHide,
  modalHeadingText,
  imgSrc,
  btnText,
}) => {
  const navigate = useNavigate();

  return (
    <Modal
      className="common_modal User_Management_Modal "
      centered
      aria-labelledby="contained-modal-title-vcenter"
      show={show}
      onHide={onHide}
      size="md"
    >
      <Modal.Header>
        <Modal.Title>
          <div className="back_div" onClick={() => onHide()}>
            <Common_Back_Btn />
          </div>
          {modalHeadingText}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="form_div">
          <p className="para_text">
            Do you want to sign in to{" "}
            <span className="inner_text">User Management? </span>
            <br /> Enter your ID and password.
          </p>

          <Form>
            <Form.Group className="form_group" controlId="formBasicName">
              <Form.Label>User Id</Form.Label>
              <Form.Control type="text" placeholder="Enter User Id" />
            </Form.Group>
            <Form.Group className="form_group" controlId="formBasicName">
              <Form.Label>Password</Form.Label>
              <Form.Control type="password" placeholder="Enter Password" />
            </Form.Group>
          </Form>
        </div>

        <div className="btn_holder">
          <Blue_Btn
            btnText={btnText}
            onClick={() => {
              onHide();
              navigate("/user-management/roles");
            }}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default User_Management_Modal;
